import { MessageCircleIcon, PencilIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { IconButton } from '@/shared/ui';

/**
 * Вкладка окна правки комментария правила: `remark` — замечание к комментарию, хранимое отдельно
 * от его текста, `text` — правка самого текста комментария.
 */
export type RuleCommentTab = 'remark' | 'text';

const TABS = [
  { tab: 'remark', labelKey: 'dialogs:expertReport.commentRemarkTab', Icon: MessageCircleIcon },
  { tab: 'text', labelKey: 'dialogs:expertReport.commentTextTab', Icon: PencilIcon },
] as const;

type Props = {
  activeTab: RuleCommentTab;
  onTabChange: (tab: RuleCommentTab) => void;
  disabled?: boolean;
};

/** Переключатель вкладок окна правки комментария правила. */
export const EvaluationRuleCommentTabs: FC<Props> = ({ activeTab, onTabChange, disabled }) => {
  const { t } = useTranslation(['dialogs']);

  return (
    <div role="tablist" className="flex items-center gap-0.5">
      {TABS.map(({ tab, labelKey, Icon }) => (
        <IconButton
          key={tab}
          variant="ghost"
          size="icon"
          type="button"
          role="tab"
          aria-selected={tab === activeTab}
          label={t(labelKey)}
          disabled={disabled}
          icon={<Icon className="size-4" />}
          className={cn('size-7', tab === activeTab && 'bg-accent text-accent-foreground')}
          onClick={() => onTabChange(tab)}
        />
      ))}
    </div>
  );
};
